<template>
  <div class="detail-row">
    <CRow>
      <CCol md="3" class="form-field">
        <label>{{ $t("holiday_setting.day_off") }} <span class="require">*</span></label>
        <b-form-input type="date" v-model="row.day_off" @change="onOffChange" />
        <span class="require">{{ errors.day_off }}</span>
      </CCol>
      <CCol md="3" class="form-field">
        <label>{{ $t("holiday_setting.type") }}</label>
        <b-form-select v-model="row.type" :options="typeOptions" />
      </CCol>
      <CCol md="3" class="form-field">
        <label>{{ $t("holiday_setting.session") }}</label>
        <b-form-select v-model="row.session" :options="sessionOptions" @change="onOffChange" />
      </CCol>
      <CCol md="2" class="form-field d-flex align-items-end">
        <b-form-checkbox v-model="row.is_compensation">
          {{ $t("holiday_setting.is_compensation") }}
        </b-form-checkbox>
      </CCol>
      <CCol md="1" class="d-flex align-items-end justify-content-end">
        <span v-if="removable" class="delete-btn" @click="$emit('remove')">
          <CIcon name="cilTrash" class="btn-icon" />
        </span>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6" class="form-field" v-if="isVisible('morning')">
        <label>{{ $t("holiday_setting.morning_off") }}</label>
        <div class="d-flex">
          <b-form-input type="time" v-model="row.start_morning_day_off" />
          <span class="mx-2">-</span>
          <b-form-input type="time" v-model="row.end_morning_day_off" />
        </div>
        <span class="require">{{ errors.start_morning_day_off || errors.end_morning_day_off }}</span>
      </CCol>
      <CCol md="6" class="form-field" v-if="isVisible('afternoon')">
        <label>{{ $t("holiday_setting.afternoon_off") }}</label>
        <div class="d-flex">
          <b-form-input type="time" v-model="row.start_afternoon_day_off" />
          <span class="mx-2">-</span>
          <b-form-input type="time" v-model="row.end_afternoon_day_off" />
        </div>
        <span class="require">{{ errors.start_afternoon_day_off || errors.end_afternoon_day_off }}</span>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="3" class="form-field">
        <label>{{ $t("holiday_setting.day_offset") }}</label>
        <b-form-input type="date" v-model="row.day_offset" @change="onOffsetChange" />
        <span class="require">{{ errors.day_offset }}</span>
      </CCol>
      <template v-if="row.day_offset">
        <CCol md="4" class="form-field">
          <label>{{ $t("holiday_setting.morning_offset") }}</label>
          <div class="d-flex">
            <b-form-input type="time" v-model="row.start_morning_day_offset" />
            <span class="mx-2">-</span>
            <b-form-input type="time" v-model="row.end_morning_day_offset" />
          </div>
          <span class="require">{{ errors.start_morning_day_offset || errors.end_morning_day_offset }}</span>
        </CCol>
        <CCol md="4" class="form-field">
          <label>{{ $t("holiday_setting.afternoon_offset") }}</label>
          <div class="d-flex">
            <b-form-input type="time" v-model="row.start_afternoon_day_offset" />
            <span class="mx-2">-</span>
            <b-form-input type="time" v-model="row.end_afternoon_day_offset" />
          </div>
          <span class="require">{{ errors.start_afternoon_day_offset || errors.end_afternoon_day_offset }}</span>
        </CCol>
      </template>
    </CRow>
  </div>
</template>

<script>
import {
  HOLIDAY_TYPE,
  SESSION,
  isSessionVisible,
  applyOffTimes,
  applyOffsetTimes
} from "./holiday-setting-detail-helpers";

// One holiday_setting_detail row. Works on a local copy and emits "input" on every change.
export default {
  name: "HolidaySettingDetailRow",
  props: {
    value: { type: Object, required: true },
    workTimes: { type: Object, default: () => ({}) },
    // { field: message } from API 422 for this row
    errors: { type: Object, default: () => ({}) },
    removable: { type: Boolean, default: true }
  },
  data() {
    return { row: { ...this.value } };
  },
  computed: {
    typeOptions() {
      return [
        { value: HOLIDAY_TYPE.HOLIDAY_LEAVE, text: this.$t("holiday_setting.type_holiday") },
        { value: HOLIDAY_TYPE.SPECIAL_LEAVE, text: this.$t("holiday_setting.type_special") }
      ];
    },
    sessionOptions() {
      return [
        { value: SESSION.FULL, text: this.$t("holiday_setting.session_full") },
        { value: SESSION.MORNING, text: this.$t("holiday_setting.session_morning") },
        { value: SESSION.AFTERNOON, text: this.$t("holiday_setting.session_afternoon") }
      ];
    }
  },
  watch: {
    row: {
      deep: true,
      handler(row) {
        this.$emit("input", { ...row });
      }
    }
  },
  methods: {
    isVisible(half) {
      return isSessionVisible(this.row.session, half);
    },
    // Date or session changed: prefill empty off hours from work time, clear hidden pair
    onOffChange() {
      applyOffTimes(this.row, this.workTimes);
    },
    onOffsetChange() {
      applyOffsetTimes(this.row, this.workTimes);
    }
  }
};
</script>

<style scoped>
.detail-row {
  border: 1px solid #d8dbe0;
  border-radius: 4px;
  padding: 0.75rem;
  margin-bottom: 0.75rem;
}
.form-field {
  margin-bottom: 0.5rem;
}
label {
  font-weight: 600;
}
.require {
  color: red;
}
.delete-btn {
  cursor: pointer;
}
.btn-icon {
  color: red;
}
</style>
